<template>
  <a
    :href="href"
    rel="nofollow"
    class="inline-block px-4 py-3 rounded border border-black border-solid items-center justify-center no-underline outline-none cursor-pointer w-full box-border"
    @click="handleClickEvent($event)"
    @click.native="handleClickEvent($event)"
  >
    <div class="flex items-center justify-center text-center">
      <img class="payment-methods__sprite" :src="copySvg" :alt="$t('loginWithApple')" />
    </div>
  </a>
</template>

<script>
import events from "@/bl-events"
import appleLoginCopyEn from "@/component-library/apple-login-button/copy/en.svg"
import appleLoginCopyDe from "@/component-library/apple-login-button/copy/de.svg"
import appleLoginCopyEs from "@/component-library/apple-login-button/copy/es.svg"

export default {
  name: "AppleLoginButton",
  props: {
    eventCategory: { type: String, default: "body-20211125-apple_login_button" },
    preSignupDataJson: { type: String, default: "" },
    lastPageBeforeLoginValue: { type: String, default: "" }
  },
  data() {
    return {
      appleLoginCopyEn,
      appleLoginCopyDe,
      appleLoginCopyEs
    }
  },
  computed: {
    copySvg() {
      if (this.$i18n.locale === "de") {
        return this.appleLoginCopyDe
      } else if (this.$i18n.locale === 'es') {
        return this.appleLoginCopyEs
      } else {
        return this.appleLoginCopyEn
      }
    },
    href() {
      let url = `/${this.$i18n.locale}/nc/apple_login`
      let params = new URLSearchParams()
      if (this.lastPageBeforeLogin) {
        params.set("last_page_before_login", this.lastPageBeforeLogin)
      }
      if (this.preSignupDataJson) {
        params.set("pre_signup_data", this.preSignupDataJson)
      }
      if (params.toString()) {
        url = `${url}?${params.toString()}`
      }
      return url
    }
  },
  methods: {
    handleClickEvent(event) {
      events.track(this.eventCategory, "1-click")

      this.$emit("click", event)
    }
  },
  i18n: {
    messages: {
      en: {
        loginWithApple: "Continue with Apple"
      },
      es: {
        loginWithApple: "Continuar con Apple"
      },
      de: {
        loginWithApple: "Mit Apple anmelden"
      }
    }
  }
}
</script>
